<template>
    <div class="h-[100%] flex flex-col gap-6">
        <ai-grid-ro
            ref="gridRoRef"
            :meta="props.meta"
            :preselectedRows="preselectedRows"
            :showToolbar="false"
            :showFilterPanel="false"
            :showGridFooter="false"
        />
        <div class="text-right">
            <dx-button class="w-[50%]" text="Выбрать" @click="selectRows" />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import AiGridRo from '@/components/ai-grid-ro/ai-grid-ro.vue';
import { DxButton } from 'devextreme-vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {
        },
    },
    rowClickCallBack: {
        type: Function,
        default: () => {
        },
    },
    cellInfo: {
        type: Object,
        default: () => {
        },
    },
});

const gridRoRef = ref();
const preselectedRows = props?.cellInfo.value && props.cellInfo.value[0] !== null ? props.cellInfo.value : [];

const selectRows = () => {
    const { keyExpr, selectedRowKeys } = gridRoRef.value.gridInstance.option();
    const gridDataSource = gridRoRef.value.gridInstance.option().dataSource;
    const row = {
        [keyExpr]: selectedRowKeys,
        [props.meta.valueExpr]: selectedRowKeys.map(key => gridDataSource.find(row => row.kod_refobject === key)[props.meta.valueExpr]).join(', '),
    };
    props.rowClickCallBack({ row, keyExpr });
};
</script>
